import Dexie from 'dexie';
//
export default class BaseDb {
	static instance = null;

	constructor(dbName, $log) {
		if (BaseDb.instance) return BaseDb.instance;

		this.$log = $log;
		this.dbName = dbName;
		this.db = new Dexie(dbName);
		this.db.version(1).stores({
			bundles: 'bundle_product_id',
			prices: 'universal_unique_id',
			brices: 'universal_unique_id',
			tags: 'key',
			view: '++id,consultation_id,name,config,iat',
			accessories: 'product_id',
			brands: 'brand_id',
			series: 'series_id',
			products: 'product_id',
		});

		BaseDb.instance = this;
		return this;
	}

	defineSchema(version, stores) {
		this.db.version(version).stores(stores);
		return this;
	}

	/**
	 * Generate unique id
	 * @returns string
	 */
	uuid() {
		return crypto.randomUUID();
	}

	mockPrice(str) {
		let sum = 0;
		for (let i = 0; i < str.length; i++) {
			sum += str.charCodeAt(i);
		}
		return sum + (sum % 100) / 100;
	}

	async clearTable(tableName) {
		await this.db[tableName]?.clear();
	}

	async put(tableName, data) {
		await this.db[tableName]?.put(data);
	}

	async bulkPut(tableName, data) {
		await this.db[tableName]?.bulkPut(data);
	}
	async get(tableName, id) {
		await this.db[tableName]?.get(id);
	}

	async getAll(tableName) {
		const all = await this.db[tableName]?.toArray();
		return all || [];
	}

	async seed(model, data) {
		if (!model || typeof model !== 'string') {
			this.$log.info('No model provided');
			return;
		}
		if (!data || !data.length === 0) {
			this.$log.error('No model data provided');
			return;
		}

		return await this.db[model].bulkPut(data);
	}
}
